import { render, staticRenderFns } from "./ImportsOverview.vue?vue&type=template&id=89881098&scoped=true&"
import script from "./ImportsOverview.vue?vue&type=script&lang=js&"
export * from "./ImportsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ImportsOverview.vue?vue&type=style&index=0&id=89881098&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89881098",
  null
  
)

export default component.exports